import { render, staticRenderFns } from "./ClientRecord.vue?vue&type=template&id=fe974df4&scoped=true"
import script from "./ClientRecord.vue?vue&type=script&lang=js"
export * from "./ClientRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe974df4",
  null
  
)

export default component.exports